import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Divider,
  Link,
} from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import Page from 'src/components/Page';
import gradients from 'src/utils/gradients';
import LoginForm from './LoginForm';
import { useAuth0 } from 'src/react-auth0-spa';
import { useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 2)
  },
  card: {
    width: theme.breakpoints.values.md,
    maxWidth: '100%',
    overflow: 'visible',
    display: 'flex',
    position: 'relative',
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%',
      width: '50%'
    }
  },
  content: {
    padding: theme.spacing(8, 4, 3, 4)
  },
  media: {
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    padding: theme.spacing(3),
    color: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  icon: {
    backgroundImage: gradients.green,
    color: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    position: 'absolute',
    top: -32,
    left: theme.spacing(3),
    height: 64,
    width: 64,
    fontSize: 32
  },
  loginForm: {
    marginTop: theme.spacing(3)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  person: {
    marginTop: theme.spacing(2),
    display: 'flex'
  },
  avatar: {
    marginRight: theme.spacing(2)
  }
}));

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Login() {
  const classes = useStyles();
  const { loginWithRedirect } = useAuth0();
  let query = useQuery();
  const [isRedirecting, setIsRedirecting] = React.useState(false);

  useEffect(() => {
    if (query.get('code') &&
      query.get('state')) {

      setIsRedirecting(true);
    }else{
      setIsRedirecting(false);
    }
  }, [query]);

  return (
    <Page
      className={classes.root}
      title="Login | weddingbudget.io"
    >
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <LockIcon className={classes.icon} />
          <Typography
            gutterBottom
            variant="h3"
          >
            Sign in
          </Typography>
          <Typography variant="subtitle2">
            Sign in to get started
          </Typography>
          <LoginForm className={classes.loginForm} isRedirecting={isRedirecting} />
          <Divider className={classes.divider} />
          <Link
            align="center"
            color="secondary"
            component="button"
            underline="always"
            onClick={() => loginWithRedirect({ screen_hint: 'signup' })}
            variant="subtitle2"
          >
            Don&apos;t have an account?
          </Link>
        </CardContent>
        <CardMedia
          className={classes.media}
          image="/images/auth2.jpg"
          title="Cover"
        />
      </Card>
    </Page>
  );
}

export default Login;
